import {withRouter} from "react-router";
import Approval from "components/complex/approval/Approval"
import React, {useEffect, useState} from "react";
import DemandApprovalService from "services/DemandApprovalService";
import {connect} from "react-redux";
import Loading from "components/Loading";
import DemandSectionsService from "services/DemandSectionsService";
import {DemandValidation} from "constants/DemandValidation";
import {getUncompletedSectionsForApproval} from "libs/getUncompletedSections";


function DemandApproval(
    {
        demandActiveApproval,
        demandApprovalHistoryList,
        demandValidation,
        match
    }) {

    const demandId = match.params.id;
    const [loading, setLoading] = useState(true);
    const [working, setWorking] = useState(false);
    const section = demandValidation.find(x => x.section === DemandValidation.APPROVAL);
    const uncompletedSections = getUncompletedSectionsForApproval(demandValidation);

    useEffect(() => {
        const approvalPromise = DemandApprovalService.getActiveApproval(demandId);
        const historyListPromise = DemandApprovalService.getApprovalHistoryList(demandId);
        Promise.all([approvalPromise, historyListPromise]).then(() => {
            setLoading(false);
        })

        return () => {
            DemandApprovalService.clearResources(DemandApprovalService.DEMAND_ACTIVE_APPROVAL_RESOURCE_ID);
            DemandApprovalService.clearResources(DemandApprovalService.DEMAND_APPROVAL_HISTORY_LIST_RESOURCE_ID);
            DemandApprovalService.clearResources(DemandApprovalService.DEMAND_APPROVAL_HISTORY_RESOURCE_ID);
        }
    }, [demandId]);

    const startApproval = () => {
        setWorking(true);
        DemandApprovalService.startApproval(demandId).then((res) => {
            if (res) {
                const approvalPromise = DemandApprovalService.getActiveApproval(demandId);
                const historyPromise = DemandApprovalService.getApprovalHistoryList(demandId);
                const sectionsPromiese = DemandSectionsService.getPreparingSections(demandId);
                Promise.all([approvalPromise, historyPromise, sectionsPromiese]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const sendToApproval = (values) => {
        setWorking(true);
        DemandApprovalService.selectApprovers(demandId, values).then(res => {
            if (res) {
                const approvalPromise = DemandApprovalService.getActiveApproval(demandId);
                const historyPromise = DemandApprovalService.getApprovalHistory(demandId, values.identity);
                Promise.all([approvalPromise, historyPromise]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const resetApproval = () => {
        setWorking(true);
        DemandApprovalService.resetApproval(demandId).then(res => {
            if (res) {
                const approvalPromise = DemandApprovalService.getActiveApproval(demandId);
                const historyPromise = DemandApprovalService.getApprovalHistoryList(demandId);
                Promise.all([approvalPromise, historyPromise]).then(() => {
                    setWorking(false);
                })
            } else {
                setWorking(false);
            }
        });
    }

    const stopApproval = () => {
        setWorking(true);
        DemandApprovalService.stopApproval(demandId).then(res => {
            if (res) {
                const approvalPromise = DemandApprovalService.getActiveApproval(demandId);
                const historyPromise = DemandApprovalService.getApprovalHistoryList(demandId);
                const sectionsPromise = DemandSectionsService.getPreparingSections(demandId);
                Promise.all([approvalPromise, historyPromise, sectionsPromise]).then(() => setWorking(false));
            } else {
                setWorking(false);
            }
        });
    }

    const sendDecision = (values) => {
        setWorking(true);
        DemandApprovalService.sendDecision(demandId, values).then(res => {
            if (res) {
                DemandApprovalService.clearResources(DemandApprovalService.DEMAND_ACTIVE_APPROVAL_RESOURCE_ID);
                DemandApprovalService.getApprovalHistory(demandId, values.identity).then(() => {});
                DemandSectionsService.getPreparingSections(demandId).then(() => {});
                setWorking(false);
            } else {
                const approvalPromise = DemandApprovalService.getActiveApproval(demandId);
                const historyPromise = DemandApprovalService.getApprovalHistory(demandId, values.identity);
                Promise.all([approvalPromise, historyPromise]).then(() => setWorking(false));
            }
        })
    }

    const loadApprovalHistory = async (approvalId) => {
        return await DemandApprovalService.getApprovalHistory(demandId, approvalId)
    }

    const getAvailableApprovers = async (approval, stage) => {
        return await DemandApprovalService.getAvailableApprovers(demandId, approval.identity, stage.identity);
    }

    const addApprovers = async (approvalId, stageId, approverIds) => {
        const resp = await DemandApprovalService.addApprovers(demandId, approvalId, stageId, approverIds);
        if (resp) {
            DemandApprovalService.getApprovalHistory(demandId, approvalId).then(() => {});
            return true;
        } else {
            return false;
        }
    }

    const deleteApprover = async (approval, stage, approver) => {
        return await DemandApprovalService.deleteApprover(demandId, approval, stage, approver);
    }

    if (loading)
        return <Loading/>

    return <Approval
                approvalObjectName='demand'
                approvalSection={section}
                uncompletedApprovalObjectSections={uncompletedSections}
                approval={demandActiveApproval}
                approvalHistoryList={demandApprovalHistoryList}
                startApproval={startApproval}
                sendToApproval={sendToApproval}
                resetApproval={resetApproval}
                stopApproval={stopApproval}
                sendDecision={sendDecision}
                loadApprovalHistory={loadApprovalHistory}
                getAvailableApprovers={getAvailableApprovers}
                addApprovers={addApprovers}
                deleteApprover={deleteApprover}
                working={working}
        />

}

export default connect((state) => ({
    demandActiveApproval: state.resources.demandActiveApproval,
    demandApprovalHistoryList: state.resources.demandApprovalHistoryList,
    demandValidation: state.resources.demandValidation
}), {})(withRouter(DemandApproval))